import { HttpClient } from '@adapters/HttpClient';
import {
  CourierFileDetail,
  CourierFilePaymentFilters,
  CourierFilePaymentsResponse,
  AddPaymentRequest,
  AddPaymentResponse,
  DeductPaymentRequest,
  DeductPaymentResponse,
  ExportPaymentsRequest,
  ExportPaymentsResponse,
} from '../models';

export class CourierFileDetailApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene detalle de un archivo de courier específico
   * GET /api/v1/courier-cod-files/{id}
   */
  async getCourierFileById(id: number): Promise<CourierFileDetail> {
    const response = await this.httpClient.get<CourierFileDetail>(
      `/courier-cod-files/${id}`
    );
    return response;
  }

  /**
   * Obtiene pagos paginados de un archivo específico
   * GET /api/v1/courier-cod-files/{id}/payments
   */
  async getCourierFilePayments(
    fileId: number,
    filters: CourierFilePaymentFilters = {}
  ): Promise<CourierFilePaymentsResponse> {
    const {
      per_page = 15,
      page = 1,
      sort_by,
      sort_direction,
    } = filters;

    const params: Record<string, any> = {
      page,
      per_page,
      ...(sort_by ? { sort_by } : {}),
      ...(sort_direction ? { sort_direction } : {}),
    };

    const response = await this.httpClient.get<CourierFilePaymentsResponse>(
      `/courier-cod-files/${fileId}/payments`,
      params,
      {},
      page === 1
    );

    return response;
  }

  /**
   * Añade un pago manual a un archivo existente
   * PUT /api/v1/courier-cod-files/{id}/add-payment
   */
  async addPayment(fileId: number, data: AddPaymentRequest): Promise<AddPaymentResponse> {
    const response = await this.httpClient.put<AddPaymentResponse>(
      `/courier-cod-files/${fileId}/add-payment`,
      data
    );

    return response;
  }

  /**
   * Registra una deducción o ajuste negativo en un archivo
   * PUT /api/v1/courier-cod-files/{id}/deduct-payment
   */
  async deductPayment(fileId: number, data: DeductPaymentRequest): Promise<DeductPaymentResponse> {
    const response = await this.httpClient.put<DeductPaymentResponse>(
      `/courier-cod-files/${fileId}/deduct-payment`,
      data
    );

    return response;
  }

  /**
   * Exporta los pagos de un archivo a Excel
   * POST /api/v1/courier-cod-files/{file_id}/payments/export
   */
  async exportPayments(
    fileId: number,
    data: ExportPaymentsRequest,
    sorting?: { column: string; direction: 'asc' | 'desc' }
  ): Promise<ExportPaymentsResponse> {
    const params: Record<string, string> = {};
    
    if (sorting) {
      params['sorting[column]'] = sorting.column;
      params['sorting[direction]'] = sorting.direction;
    }

    const response = await this.httpClient.post<ExportPaymentsResponse>(
      `/courier-cod-files/${fileId}/payments/export`,
      data,
      params
    );

    return response;
  }
}

